import { type SetElementType } from '../utils/types/set-element-type';

/**
 * DTO sort direction values.
 * This list is rather artificial, In our real projects sorting is mapped like this:
 * Ascending - (empty string)
 * Descending - `-`
 * But for now, the decision has been made to leave it as is just for example purposes.
 * When a more suitable and realistic example appears in the project, this DTO should be removed.
 */
export const sortDirectionDtoValues = new Set([
  '+',
  '-',
] as const);

/** Sort direction DTO. */
export type SortDirectionDto = SetElementType<typeof sortDirectionDtoValues>;
